import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface UserInfoResponse {
  id: number
  code?: string | number | undefined
  uuid: string
  first_name: string | null
  last_name: string | null
  first_name_en: string | null
  last_name_en: string | null
  gender: string | null
  birth_date: string | null
}

export function getUserInfoAction(userUuid: string): Promise<ApiResponse<UserInfoResponse>> {
  return api.get<ApiResponse<UserInfoResponse>>(`/users/${userUuid}/user-info`)
}
